import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  SendButton,
} from "@chatscope/chat-ui-kit-react";
import { Modal, Button, Form } from "react-bootstrap";
import {
  showSwalQuestion,
  showSwalSuccess,
  showSwalError,
} from "../../utils/swal";
import useInterval from "../../hooks/useInterval";
import { MdOutlineMessage } from "react-icons/md";

import useAxios from "../../services/useAxios";
import { useState, useEffect, useContext, useRef } from "react";
import { ReactSelect, FileInput } from "../kits/Inputs/Inputs.tsx";
import useWindowSize from "../../hooks/useWindowSize";
import Reminder from "./modals/Reminder";
import AddClue from "./modals/AddClue";
import ManagementNote from "./modals/ManagementNote";
import FinancialReport from "./modals/FinancialReport";
import CallPrice from "./modals/CallPrice";
import AuthenticationContext from "../../Authentication/AuthenticationContext.ts";
import MassagePreview from "./modals/MassagePreview";
import profileImage from "../../assets/images/profileImage.jpg";
import {
  HeartIcon,
  BellIcon,
  SearchIcon,
  ArrowRightIcon1,
  ArrowLeftIcon1,
  CalendarIcon,
  NoteBookIcon,
  DollarIcon,
  PlusSquareIcon,
  DollarIcon1,
  ChatIcon,
} from "../kits/Icons.tsx";
import PreparedMessagesModal from "./modals/PreparedMessagesModal";
import CallPriceNew from "./modals/CallPriceNew";
import { additionalPrice } from "../../utils/helperFunction";

export default function ChatBox({
  chatboxShow,
  setChatboxShow,
  setContactBoxShow,
  selectedContact,
  setLoadingChat,
  get_msg,
  allMsg,
}) {
  const { userInfo } = useContext(AuthenticationContext);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);
  const [show5, setShow5] = useState(false);
  const [show6, setShow6] = useState(false);
  const [show7, setShow7] = useState(false);
  const [reminderText, setReminderText] = useState("");
  const fileData = useRef(null);
  const winSize = useWindowSize();
  const [timer, setTimer] = useState("");
  const [select, setSelect] = useState("");

  const [hashtagList, setHashtagList] = useState([
    {
      label: "پیش فاکتور",
      value: 1,
    },
    { label: "مالی", value: 2 },
  ]);
  const [msgInputValue, setMsgInputValue] = useState("");
  const [files, setFiles] = useState([]);
  const [text, setText] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [adminMsg, setAdminMsg] = useState(false);

  const { execute: SendMessage } = useAxios("api/chat_send_message");
  const { loading, execute: SendImg } = useAxios("api2/upload_img");
  // for new estelam price start
  // const additionalPrice = [
  //   {
  //     title: "هزینه دسته بندی",
  //     price: "450",
  //     needNumber: false,
  //     checked: false,
  //     count: 1,
  //     more_option_value: "1",
  //     id: 1,
  //     priority: 9,
  //   },
  //   {
  //     title: "هزینه چاپ سیلک معمولی",
  //     price: "550",
  //     needNumber: true,
  //     checked: false,
  //     count: 1,
  //     more_option_value: "1",
  //     id: 2,
  //     priority: 1,
  //   },
  //   {
  //     title: `هزینه چاپ سیلک `,
  //     description: "(طلایی، نقره ای، سفید)",
  //     price: "750",
  //     needNumber: true,
  //     checked: false,
  //     count: 1,
  //     more_option_value: "1",
  //     id: 3,
  //     priority: 2,
  //   },
  //   // {
  //   //   title: "هزینه چاپ سیلک نقره ای",
  //   //   price: "750",
  //   //   needNumber: true,
  //   //   checked: false,
  //   //   count: 1, more_option_value:''1,
  //   //   id: 4,
  //   // priority:  // },
  //   // {
  //   //   title: "هزینه چاپ سیلک سفید",
  //   //   price: "750",
  //   //   needNumber: true,
  //   //   checked: false,
  //   //   count: 1, more_option_value:''1,
  //   //   id: 5,
  //   // priority:  // },
  //   {
  //     title: "هزینه کلیشه سیلک",
  //     price: "100000",
  //     needNumber: false,
  //     checked: false,
  //     count: 1,
  //     more_option_value: "1",
  //     id: 6,
  //     priority: 8,
  //   },
  //   {
  //     title: "هزینه HIBag",
  //     price: "600",
  //     needNumber: false,
  //     checked: false,
  //     count: 1,
  //     more_option_value: "1",
  //     id: 7,
  //     priority: 7,
  //   },
  //   {
  //     title: "طرحدار",
  //     price: "1000",
  //     needNumber: false,
  //     checked: false,
  //     count: 1,
  //     more_option_value: "1",
  //     id: 8,
  //     priority: 6,
  //   },
  //   {
  //     title: "دکمه",
  //     price: "600",
  //     needNumber: true,
  //     checked: false,
  //     count: 1,
  //     more_option_value: "1",
  //     id: 9,
  //     priority: 5,
  //   },
  //   {
  //     title: "چاپ فلکسو",
  //     more_option: [
  //       { title: "یکطرفه", value: 1 },
  //       { title: "دوطرفه", value: 2 },
  //     ],
  //     price: "350",
  //     needNumber: true,
  //     checked: false,
  //     count: 1,
  //     more_option_value: "1",
  //     id: 10,
  //     priority: 3,
  //   },
  //   {
  //     title: "چاپ افست",
  //     more_option: [
  //       { title: "یکطرفه", value: 1 },
  //       { title: "دوطرفه", value: 2 },
  //     ],
  //     price: "3500",
  //     needNumber: true,
  //     checked: false,
  //     more_option_value: "1",
  //     count: 1,
  //     id: 11,
  //     priority: 4,
  //   },
  // ];
  const [dataCheckPrice, setDataCheckPrice] = useState({
    additionalPrice: additionalPrice.sort((a, b) => {
      return a?.priority - b?.priority;
    }),
  });
  const [priceCheckPrice, setPriceCheckPrice] = useState(-1);
  const reset = () => {
    setDataCheckPrice({
      additionalPrice: additionalPrice,
    });
    setPriceCheckPrice(-1);
  };
  // for new estelam price end

  const uploadImage = async (filesArray) => {
    const promises = [];
    let filesId = [];
    filesArray.map(async (item) => {
      let result = SendImg({ file: item });
      promises.push(result);
    });
    const results = await Promise.all(promises);
    results.map((item) => {
      if (item["status"]) {
        filesId.push(item["result"]["id"]);
      }
    });
    return filesId;
  };

  const sendHandler = (filesArray, sendTxt) => {
    if (sendTxt == "") {
      showSwalError("متن خالی است");
      return;
    }
    setSpinner(true);
    setText("");
    setFiles([]);

    uploadImage(filesArray).then((filesId) => {
      SendMessage({
        sender_id: userInfo["id"],
        receiver_id: selectedContact?.id,
        text: sendTxt.replaceAll(/<[^>]*>/g, ""),
        file_id: filesId.toString(),
        is_admin_note: adminMsg ? 1 : 0,
        customer_id: selectedContact?.customer_id,
      }).then((result) => {
        if (result["status"] == 1) {
          setSpinner(false);
          setShow6(false);
          setShow5(false);
          reset();
          // showSwalSuccess("ارسال شد");
        } else {
          setSpinner(false);
          setShow6(false);
          setText("");
          showSwalError("لطفا دوباره امتحان کنید");
        }
      });
    });
  };

  const { execute: SendLinkChat } = useAxios("api/chat_send_link");
  const sendLinkChat = () => {
    showSwalQuestion("آیا از ارسال لینک مطمئن هستید؟").then((result) => {
      if (result.isConfirmed) {
        SendLinkChat({
          admin_id: userInfo["id"],
          customer_id: selectedContact?.customer_id,
        })
          .then((data) => {
            if (!(data.status == 1)) {
              showSwalError("مشکلی در ارسال پیام پیش آمده است");
            }
            if (data.status == 1) {
              showSwalSuccess("  ارسال پیام با موفقیت انجام شد");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  const { execute: get_customers } = useAxios("api2/Find_Customers");
  const { execute: get_campaign } = useAxios("api2/Find_Campaign");
  const { execute: upload_img } = useAxios("api2/upload_img");
  const [customer, setCustomer] = useState([]);
  const [campaign, setCampaign] = useState([]);
  const [step, setStep] = useState([]);
  const add_step_link = () => {
    setStep([]);
    get_customers().then((data) => {
      let array = [];
      data.map((item) => {
        array.push({
          value: item.id,
          label: `${item.firstname} ${item.lastname}`,
        });
      });
      setCustomer(array);
    });
    get_campaign().then((data) => {
      let array = [];
      data.map((item) => {
        array.push({
          value: item.id,
          label: item.title,
        });
      });
      setCampaign(array);
    });
  };
  const uploadFile = (file) => {
    if (file.length > 0) {
      setFiles(file);
      handleShow6();
    }
  };

  const handleClick = () => {
    fileData.current.click();
  };

  const handleShow = () => setShow(true);
  const handleShow2 = () => setShow2(true);
  const handleShow3 = () => setShow3(true);
  const handleShow4 = () => setShow4(true);
  const handleShow5 = () => setShow5(true);
  const handleShow6 = () => setShow6(true);
  const handleShow7 = () => setShow7(true);
  useEffect(() => {
    setText("");
  }, [selectedContact]);
  return (
    <div
      className="d-flex flex-column"
      style={{ height: "100%", width: "100%" }}
    >
      <div className=" w-100" style={{ borderBottom: "1px solid #d1dbe3" }}>
        {winSize.width < 700 && selectedContact != "" && (
          <div className="d-flex justify-content-between align-items-center p-2">
            <div className="d-flex align-items-center">
              <img
                src={profileImage}
                style={{ width: 40, height: 40, borderRadius: "50%" }}
              />
              <h6 className="fw-bold text-purple mx-3">
                {selectedContact?.fullname}
              </h6>
            </div>
            <div
              className="mx-2 cursor-pointer"
              onClick={() => {
                winSize.width < 700 && setChatboxShow(false);
                winSize.width < 700 && setContactBoxShow(true);
              }}
            >
              <ArrowLeftIcon1 color="#9aa0a8" />
            </div>
          </div>
        )}
        <div className="d-flex align-items-center pb-3">
          <div className="d-flex flex-wrap mt-2">
            <div className="mx-2 my-1">
              <button
                onClick={handleShow5}
                className="d-flex justify-content-between align-items-center  text-white bg-navy  p-2 rounded fs-14"
              >
                <DollarIcon
                  style={{ width: 18, height: 18, marginLeft: 9 }}
                  color="white"
                />
                استعلام قیمت
              </button>
            </div>
            <div className="mx-2 my-1">
              <button
                onClick={() => sendLinkChat()}
                className=" d-flex justify-content-between align-items-center  text-white bg-navy  p-2 rounded fs-14"
              >
                <ChatIcon
                  style={{ width: 18, height: 18, marginLeft: 9 }}
                  color="white"
                />
                ارسال لینک چت
              </button>
            </div>
            {/* <div className="mx-2 my-1">
              <button
                onClick={() => {
                  handleShow2();
                  add_step_link();
                }}
                className=" d-flex justify-content-between align-items-center  text-white bg-navy  p-2 rounded fs-14"
              >
                <PlusSquareIcon
                  style={{ width: 18, height: 18, marginLeft: 9 }}
                  color="white"
                />
                افزودن سرنخ
              </button>
            </div> */}
            {/* <div className="mx-2 my-1">
              <button
                onClick={handleShow4}
                className="d-flex justify-content-between align-items-center  text-white bg-navy p-2 rounded  fs-14"
              >
                <DollarIcon1
                  style={{ width: 18, height: 18, marginLeft: 9 }}
                  color="white"
                />
                گزارش مالی
              </button>
            </div> */}
            <div className="mx-2 my-1">
              <button
                onClick={handleShow}
                className="d-flex justify-content-between align-items-center text-white bg-navy  p-2 rounded fs-14"
              >
                <CalendarIcon
                  style={{ width: 16, height: 16, marginLeft: 9 }}
                  color="white"
                />
                افزودن یادآور
              </button>
            </div>
            <div className="mx-2 my-1">
              <button
                onClick={handleShow3}
                className="d-flex justify-content-between align-items-center  text-white bg-navy p-2 rounded  fs-14"
              >
                <NoteBookIcon
                  style={{ width: 16, height: 16, marginLeft: 9 }}
                  color="white"
                />
                یادداشت مدیریتی
              </button>
            </div>
            <div className="mx-2 my-1">
              <button
                onClick={handleShow7}
                className="d-flex justify-content-between align-items-center  text-white bg-navy p-2 rounded  fs-14"
              >
                <MdOutlineMessage
                  style={{ width: 16, height: 16, marginLeft: 9 }}
                  color="white"
                />
                پیام‌های آماده
              </button>
            </div>
          </div>
        </div>
        {/* <div className="mx-3 mb-2">
          <ReactSelect
            itemsList={hashtagList}
            isMulti={true}
            //  inputValue={} onChangeFunc={()=>{}}
          />
        </div> */}
      </div>
      <div
        className=" flex-grow-1"
        style={{
          // overflowY: "scroll",
          // height:
          //   winSize.width > 1320
          //     ? winSize.height - 270
          //     : winSize.width > 700
          //     ? winSize.height - 280
          //     : winSize.width > 430
          //     ? winSize.height - 330
          //     : winSize.height - 350,
          height: (winSize.height * 60) / 100,
          width: "100%",
          position: "relative",
        }}
      >
        <Form.Control
          onChange={(e) => {
            uploadFile(e.target.files);
          }}
          className="d-none"
          ref={fileData}
          type="file"
        />

        <MainContainer dir="ltr">
          <ChatContainer>
            <MessageList>{allMsg?.map((item) => item)}</MessageList>
            <div id="message-anchor" />
            <MessageInput
              value={text}
              onChange={(e) => {
                setText(e);
              }}
              onAttachClick={handleClick}
              onSend={(e) => {
                sendHandler(files, text);
              }}
              placeholder="اینجا تایپ کنید ... "
            />
          </ChatContainer>
        </MainContainer>
      </div>
      <Reminder
        show={show}
        setShow={setShow}
        reminderText={reminderText}
        setReminderText={setReminderText}
        selectedContact={selectedContact}
      />
      <AddClue
        show={show2}
        setShow={setShow2}
        customer={customer}
        campaign={campaign}
        step={step}
        setStep={setStep}
      />
      <ManagementNote
        show={show3}
        setShow={setShow3}
        selectedContact={selectedContact}
      />
      <FinancialReport show={show4} setShow={setShow4} />
      {/* <CallPrice show={show5} setShow={setShow5} sendHandler={sendHandler} /> */}
      {/* shFazeli 1402/05/10 استعلام قیمت جدید داشتیم مدال قبل کامنت شد */}
      <CallPriceNew
        show={show5}
        setShow={setShow5}
        sendHandler={sendHandler}
        dataCheckPrice={dataCheckPrice}
        setDataCheckPrice={setDataCheckPrice}
        priceCheckPrice={priceCheckPrice}
        setPriceCheckPrice={setPriceCheckPrice}
        reset={reset}
      />
      <MassagePreview
        show={show6}
        setShow={setShow6}
        files={files}
        setFiles={setFiles}
        setText={setText}
        text={text}
        adminMsg={adminMsg}
        setAdminMsg={setAdminMsg}
        sendHandler={sendHandler}
        spinnerStatus={spinner}
      />

      <PreparedMessagesModal
        receiver_id={selectedContact?.id}
        showModal={show7}
        setShowModal={setShow7}
        selectedContact={selectedContact}
      />
    </div>
  );
}
